import apiUrl from '../../../constants'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
import moment from 'moment'
import CryptoJS from 'crypto-js'
import {
	Validator
} from 'vee-validate'
import SimpleEncrypt from 'simple-encryptor'

export default {
	name: 'moveorderdetailsAccordian',
	components: {
		VueElementLoading
	},
	props: ['selectedRow', 'filterData'],
	data() {
		return {
			moveorderid: this.selectedRow.moveorderid,
			urlclientid: this.filterData.clientid,
			urlwarehouseid: this.filterData.warehouseid,
			isLoading: false,
			// initialize form field
			listOrderMasterdata: [],
			listOrderDetailsData: [],
			putawayOrderLogDetail: [],
			shipMasterData: [],
			getdata: [],
			//	moveorderid: '',
			putawayLogCount: 0,
			shipmentDetailsCount: 0,
			orderModifyDetails: [],
			pickedOrderLogDetail: [],
			orderDetailsCount: 0,
			pickedLogCount: 0,
			expanded: false,
			accordianTab: {
				1: false,
				2: false,
				3: false,
				4: false,
				5: false
			},

		}
	},
	created: function () {

	},
	filters: {
		moment: function (date) {
			return moment(date).format('DD-MM-YYYY');
		},

	},
	computed: {

	},
	mounted() {

		this.key = '5VxHu9PR8QgPq7h67cUG0H34rYZQZmey';
		this.encryptor = SimpleEncrypt(this.key);
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		var loginuseremail = userdetail.email;
		this.getorderDetails();

		this.getOrderItemDetails();
		this.getPickingDetails();
		this.getPutawayDetails();
		this.data();
	},
	methods: {
		showList() {
			this.$emit("goBackToParent")
		},
		data() {
			this.getdata.push(this.backtoparent)
		},

		// encryptData(encData) {
		// 	return this.encryptor.encrypt(encData);
		// },
		// decryptData(decData) {
		// 	return this.encryptor.decrypt(decData);
		// },
		expandAll() {
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		collapseAll() {
			this.expanded = false;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = false;
			}
		},
		toggleCheck(tabid) {
			for (var key in this.accordianTab) {
				if (tabid != key) {
					this.accordianTab[key] = false;
				}
			}
		},
		// getScore(val) {
		// 	if (!val) {
		// 		return 0.00
		// 	}
		// 	return val.toFixed(2);
		// },
		// dateFormatDetail(date) {
		// 	if (!date) return '';
		// 	return moment(date).format('LLLL');
		// },

		toUpper(str) {
			if (str !== null && str !== undefined) {
				return str.charAt(0).toUpperCase() + str.slice(1);
			} else {
				return '--'
			}

		},
		getorderDetails() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.isLoading = true;
			this.input = ({
				moveorderid: this.moveorderid,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'moveorderListorderwise',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					console.log(result);
					this.listOrderMasterdata = result.data.data[0];
					console.log(this.listOrderMasterdata, "listOrderMasterdata");

					this.isLoading = false;

				},
					error => {
						console.error(error)
					})
		},
		// /	
		getOrderItemDetails() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.isLoading = true;
			this.input = ({
				moveorderid: this.moveorderid,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'moveorderItemListOrderwise',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					console.log(result);
					this.listOrderDetailsData = result.data.data;
					this.orderDetailsCount = this.listOrderDetailsData.length
					console.log(this.listOrderDetailsData, "listOrderDetailsData");

					this.isLoading = false;

				},
					error => {
						console.error(error)
					})
		},



		getPickingDetails() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.isLoading = true;
			this.input = ({
				moveorderid: this.moveorderid,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid,
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'moveorderPickingDetailsOrderwise',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.pickedOrderLogDetail = result.data.data;
					this.pickedLogCount = this.pickedOrderLogDetail.length;

					this.isLoading = false;
				},
					error => {
						console.error(error)
					})
		},
		getPutawayDetails() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.isLoading = true;
			this.input = ({
				moveorderid: this.moveorderid,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid,
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'moveorderPutAwayDetailsOrderwise',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.putawayOrderLogDetail = result.data.data;
					this.putawayLogCount = this.putawayOrderLogDetail.length;

					this.isLoading = false;
				},
					error => {
						console.error(error)
					})
		},



	}
}



// WEBPACK FOOTER //
// ./src/views/components/moveorderdetailsAccordian/moveorderdetailsAccordian.component.js